import { ConfigService } from "../services/config.service";

export class NumFactuValidator {
	private static readonly onlyNumberOrSlashRegex = /^[0-9/]+$/;

	static validate(num: string | undefined) {
		num = num?.trim() ?? "";

		// Si pas de regex alors aucune validation à faire
		return !this.regex || this.regex.test(num);
	}

	static _regex: RegExp | null = null;

	static get regex(): RegExp | null {
		if (this._regex) return this._regex;

		const pattern = ConfigService.config.workflows.teleExpertises.numFacturationRegex;

		if (pattern) {
			this._regex = new RegExp(decodeURIComponent(pattern));
			return this._regex;
		}

		return null;
	}
}